import { Link } from "wouter";
import { ChevronRight } from "lucide-react";
import { SPINE, nextStep, type SpineStep } from "@/lib/spine";

interface NextStepFooterProps {
  currentStep: SpineStep["key"];
  projectId: string;
}

export default function NextStepFooter({ currentStep, projectId }: NextStepFooterProps) {
  const next = nextStep(currentStep);

  return (
    <div
      className="fixed bottom-0 left-64 right-0 px-8 py-4 border-t flex items-center justify-between"
      style={{
        backgroundColor: "#0B0B0C",
        borderColor: "rgba(229,231,235,0.08)",
      }}
    >
      <Link href="/">
        <button className="text-xs font-medium transition-colors" style={{ color: "#9CA3AF" }}>
          Save &amp; exit to Dashboard
        </button>
      </Link>

      <div>
        {next ? (
          <Link href={`/projects/${projectId}${next.path}`}>
            <button
              className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-white transition-all"
              style={{ backgroundColor: "#F97316" }}
            >
              Next: {next.label}
              <ChevronRight size={16} />
            </button>
          </Link>
        ) : (
          <button
            className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold text-white transition-all"
            style={{ backgroundColor: "#F97316" }}
          >
            Export proposal
            <ChevronRight size={16} />
          </button>
        )}
      </div>
    </div>
  );
}
